import React from 'react';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useSubscriptionCheck from '../../common/SubscriptionCheck';

function BusinessListPageActions() {
  const navigate = useNavigate();
  const { checkSubscription, SubscriptionModal } = useSubscriptionCheck();

  const handleCreateAction = () => {
    if (!checkSubscription()) {
      return;
    }
    navigate('/business-profiles/create');
  };

  return (
    <>
      <Button
        id="create-business-profile"
        key="add-new-business"
        variant="contained"
        color="primary"
        onClick={handleCreateAction}
      >
        + Create New Business
      </Button>
      <SubscriptionModal />
    </>
  );
}

export default BusinessListPageActions;
